module.exports = __webpack_public_path__ + "static/media/GothamRnd-Light.3003b6ac.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Light.woff
 ** module id = 1352
 ** module chunks = 0
 **/